import React, { memo } from "react"
import Absences from "./Absences.icon"
import Bed from "./Bed.icon"
import Bell from "./Bell.icon"
import ChevronUp from "./ChevronUp.icon"
import Conflict from "./Conflict.icon"
import ConflictPending from "./ConflictPending"
import ConflictResolved from "./ConflictResolved"
import ConflictToResolve from "./ConflictToResolve"
import Door from "./Door.icon"
import DownloadCsv from "./DownloadCsv.icon"
import DownloadPdf from "./DownloadPdf.icon"
import Drag from "./Drag.icon"
import Employees from "./Employees.icon"
import Error from "./Error.icon"
import Home from "./Home.icon"
import Info from "./Info.icon"
import List from "./List.icon"
import MoreVertical from "./MoreVertical.icon"
import PersonalPlanning from "./PersonalPlanning.icon"
import Planning from "./Planning.icon"
import Printer from "./Printer.icon"
import Rooms from "./Rooms.icon"
import Search from "./Search.icon"
import Chair from "./SelectorList/Chair.icon"
import Counter from "./SelectorList/Counter.icon"
import DoorSelect from "./SelectorList/Door.icon"
import Phone from "./SelectorList/Phone.icon"
import Radiograph from "./SelectorList/Radiograph.icon"
import Star from "./SelectorList/Star.icon"
import Sterilization from "./SelectorList/Sterilization.icon"
import Stethoscope from "./SelectorList/Stethoscope.icon"
import Syringe from "./SelectorList/Syringe.icon"
import { SVG } from "./style"
import Upload from "./Upload.icon"
import Warning from "./Warning.icon"
import Edit from "./Edit"

export function Icons(): JSX.Element {
  return (
    <SVG>
      <Absences />
      <Bed />
      <Bell />
      <Chair />
      <ChevronUp />
      <Conflict />
      <ConflictToResolve />
      <ConflictResolved />
      <ConflictPending />
      <Counter />
      <Door />
      <DoorSelect />
      <DownloadPdf />
      <Drag />
      <Employees />
      <Error />
      <Home />
      <Info />
      <List />
      <Phone />
      <PersonalPlanning />
      <Planning />
      <Printer />
      <Radiograph />
      <Rooms />
      <Search />
      <Star />
      <Sterilization />
      <Stethoscope />
      <Syringe />
      <Upload />
      <Warning />
      <DownloadCsv />
      <MoreVertical />
      <Edit />
    </SVG>
  )
}

export default memo(Icons)
